import { styled } from '@nx-kit/styling';
import { ComposedLink } from 'components/atoms/Link/Link';

export const TextStyled = styled.text`
  fill: white;
  font-family: inherit;
  font-size: 11px;
`;

export const LinkToMapStyled = styled(ComposedLink)`
  display: flex;
  cursor: pointer;
  text-decoration: underline;
`;
